/**
 * Key on a query's `meta` naming a failing poll for telemetry.
 *
 * The contract between a polled query and the global query cache: a query that sets this label
 * gets its failures reported once per run of consecutive failures, rather than once per attempt or
 * once per component observing it. See `static/ld/query-cache-events/report-poll-error.ts`.
 */
export const POLL_ERROR_LABEL_META_KEY = 'pollErrorLabel';
